var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSubscriptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.117 6.8L14.6587 3.04167C14.3441 2.69776 13.8998 2.50132 13.4337 2.5H6.56702C6.1009 2.50132 5.65664 2.69776 5.34201 3.04167L1.88368 6.8C1.74283 6.95496 1.66547 7.15726 1.66701 7.36667V7.61667C1.66663 7.81138 1.73445 8.00007 1.85868 8.15L9.35868 17.2C9.51731 17.3905 9.75249 17.5004 10.0003 17.5C10.2482 17.5004 10.4834 17.3905 10.642 17.2L18.142 8.15C18.2663 8.00007 18.3341 7.81138 18.3337 7.61667V7.36667C18.3352 7.15726 18.2579 6.95496 18.117 6.8ZM10.0003 15.3833L7.68368 8.08333C7.57056 7.72224 7.22835 7.4827 6.85035 7.5H3.50868L6.56702 4.16667H13.4337L11.0503 6.8C10.9373 6.92185 10.9075 7.09921 10.9745 7.2513C11.0415 7.4034 11.1925 7.50113 11.3587 7.5H16.492L10.0003 15.3833Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubscriptions);
export default __webpack_public_path__ + "static/media/icon-subscriptions.bf5c4e52.svg";
export { ForwardRef as ReactComponent };